import React, {  } from 'react';
import { retryLazyImport } from '../../Store/SessionManager';
// import './FormComponent.scss';

import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormHelperText,
} from '@mui/material';



import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import CustomFormTitle from './CustomFormTitle';
import { CustomRadioButtonInterface } from '../../Models/Common/FormFieldComponentInterfaces';

const CustomTooltip = React.lazy(() => retryLazyImport(() => import('./CustomTooltip')));

const CustomRadioButton = (fieldProps: CustomRadioButtonInterface) => {
    //Variables
    var className = "radioFieldContainer " + (fieldProps.radioButtonType == ButtonType.PRIMARY ? 'primaryRadioButton'
        : (fieldProps.radioButtonType == ButtonType.SECONDARY || fieldProps.disabled ? "cancelRadioButton"
            : (fieldProps.radioButtonType == ButtonType.SUCCESS ? 'successRadioButton'
                // : (fieldProps.radioButtonType == ButtonType.SUCCESS_LIGHT ? 'successLightRadioButton'
                : (fieldProps.radioButtonType == ButtonType.DELETE ? "dangerRadioButton"
                    : (fieldProps.radioButtonType == ButtonType.WARNING ? 'warningRadioButton' : 'secondaryRadioButton')))));

    className += (fieldProps.isAligned ? " rfcAligned" : "") + (fieldProps.fieldValue ? ' filledInput' : '') + (fieldProps.isHidden ? " hiddenField" : "") + (fieldProps.fieldClassName != null && fieldProps.fieldClassName != "" ? " " + fieldProps.fieldClassName : "");

    //Rendering UIs
    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

    const renderRadioButton = () => {
        if (fieldProps?.options?.length > 0) {
            return <FormControl error={errorMsg != null} variant="standard">
                <RadioGroup {...{
                    'aria-labelledby': 'demo-controlled-radio-buttons-group',
                    name: "controlled-radio-buttons-group",
                    value: fieldProps.fieldValue,
                    onChange: (e: any) => { fieldProps.handleOnChange(e.target.value) },
                }} >
                    {fieldProps?.options?.map((opt: any) => (
                        <FormControlLabel key={GlobalFunctionHelper.getRanHex(24)} {...{
                            // key: GlobalFunctionHelper.getRanHex(24),
                            value: opt.id,
                            control: <Radio />,
                            disabled: fieldProps.disabled,
                            label: fieldProps.hideRadioLabels ? "" : opt.name,
                        }} />
                    ))}
                </RadioGroup>
                <FormHelperText>{errorMsg}</FormHelperText>
            </FormControl>
        } else {
            return "";
        }
    }

    return <div className={className}>
        <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={fieldProps.hideLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />
        {renderRadioButton()}
    </div>
}

export default CustomRadioButton;